// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-common-biz-components-src-update-user-avatar-index-module__avatar-wrap-CHgx0E {
  position: relative;
}

.\\------packages-common-biz-components-src-update-user-avatar-index-module__avatar-wrap-CHgx0E .\\------packages-common-biz-components-src-update-user-avatar-index-module__avatar-zctdMt {
  cursor: default;
  width: 80px;
  height: 80px;
}

.\\------packages-common-biz-components-src-update-user-avatar-index-module__avatar-wrap-CHgx0E .\\------packages-common-biz-components-src-update-user-avatar-index-module__mask-unn_lF {
  cursor: pointer;
  visibility: hidden;
  border-radius: 100%;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  display: flex;
  position: absolute;
  top: 0;
}

.\\------packages-common-biz-components-src-update-user-avatar-index-module__avatar-wrap-CHgx0E .\\------packages-common-biz-components-src-update-user-avatar-index-module__mask-unn_lF:hover {
  visibility: visible;
  background-color: rgba(22, 22, 26, .6);
}

.\\------packages-common-biz-components-src-update-user-avatar-index-module__avatar-wrap-CHgx0E:hover .\\------packages-common-biz-components-src-update-user-avatar-index-module__mask-unn_lF {
  color: #fff;
  visibility: visible;
  background-color: rgba(22, 22, 26, .6);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar-wrap": `------packages-common-biz-components-src-update-user-avatar-index-module__avatar-wrap-CHgx0E`,
	"avatarWrap": `------packages-common-biz-components-src-update-user-avatar-index-module__avatar-wrap-CHgx0E`,
	"avatar": `------packages-common-biz-components-src-update-user-avatar-index-module__avatar-zctdMt`,
	"mask": `------packages-common-biz-components-src-update-user-avatar-index-module__mask-unn_lF`
};
export default ___CSS_LOADER_EXPORT___;
